import { Link } from 'react-router-dom';

interface CategoryCardProps {
  slug: string;
  name: string;
  icon: string;
  description: string;
  color: string;
  count: number;
  onClick?: () => void;
}

export default function CategoryCard({ slug, name, icon, description, color, count, onClick }: CategoryCardProps) {
  const bgColor = color === 'primary' ? 'bg-primary-100/70' : color === 'accent' ? 'bg-accent-100/70' : 'bg-secondary-100/70';
  const textColor = color === 'primary' ? 'text-primary-500' : color === 'accent' ? 'text-accent-500' : 'text-secondary-500';
  const hoverBorder = color === 'primary' ? 'hover:border-primary-300' : color === 'accent' ? 'hover:border-accent-300' : 'hover:border-secondary-300';

  return (
    <Link
      to={`/category/${slug}`}
      onClick={onClick}
      className={`group block bg-background-50 border border-background-200/70 rounded-lg p-5 ${hoverBorder} transition-all duration-300 cursor-pointer`}
    >
      <div className={`w-12 h-12 ${bgColor} rounded-lg flex items-center justify-center mb-4`}>
        <i className={`${icon} text-xl ${textColor}`}></i>
      </div>
      <h3 className="text-base font-semibold text-foreground-950 mb-2 group-hover:text-primary-500 transition-colors">
        {name}
      </h3>
      <p className="text-sm text-foreground-600 leading-relaxed mb-3 line-clamp-2">
        {description}
      </p>
      <span className="text-xs text-foreground-500">{count} 篇文章</span>
    </Link>
  );
}